import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langMessages from './index'
import { appConfig } from '@/store/config'

Vue.use(VueI18n)

const fallback = 'en'

let locale = window.localStorage.language || navigator.language.substr(0, 2).toLowerCase() || fallback

if (!appConfig.state.languages[locale]) {
  locale = fallback
}

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: fallback,
  silentTranslationWarn: process.env.NODE_ENV !== 'development',
  messages: langMessages
})

export { i18n }



// WEBPACK FOOTER //
// ./src/locale/i18n.js